export const INVENTORY_CODES = {
  I001: 'inventoryNotExist',
  I002: 'inventorySerialNumberExist',
};
